import { useQuery } from "@tanstack/react-query";
import { queryClient } from "shared/api/queryClient";
import { getStudioDetails } from "../api/getStudioDetails";

type PropsQuery = {
  studioId: number;
};

export const useStudioDetailsQuery = ({ studioId }: PropsQuery) => {
  return useQuery({
    queryKey: ["studioDetails", studioId],
    queryFn: async () => {
      const studio = await getStudioDetails(studioId.toString());
      return studio;
    },
    enabled: !!studioId,
  });
};

export const invalidateStudioDetailsQuery = (studioId: number | string) => {
  return queryClient.invalidateQueries({
    queryKey: ["studioDetails", studioId],
  });
};
